module.exports = __webpack_public_path__ + "img/next-1.e69601c8.jpg";